module.exports = __webpack_public_path__ + "static/media/AddCar.db87bdaa.png";